import React, { Component } from 'react';
import MaterialTable from 'material-table';
import 'components/transactionEditor/Wizards/ResponseTreeWizard.css';
import clsx from 'clsx';
import { RequestTabState } from '../../../views/AssetCatalog/Transactions/TransactionEditor/RequestTab/RequestTab';
import i18n from '../../../i18n';
import _ from 'lodash';
import ResponseWizardDetail from './ResponseWizardDetail';
import { getIdForResponseWizard } from '../../../utils/miscUtil';

type ResponseTreeWizardProps = {
  sampleBodyJsonUi?: string;
  requestBodyTreeJson?: string;
  requestTabState: RequestTabState;
  selectedNode: number;
  requestBodyType: string;
  updateLeafNodeValue: (id: string, value: string) => void;
  serviceId?: number;
};

interface LeafNodeValues {
  id: string;
  value: string;
}

class ResponseTreeWizard extends Component<ResponseTreeWizardProps> {
  tableRef: any = React.createRef();

  state = {
    leafNodeValues: [] as LeafNodeValues[],
    /** For visual indication about last row changed */
    latestUpdatedRow: null,
  };

  getLeafNodeValue = (rowData: any) => {
    const idToEvaluate = getIdForResponseWizard(rowData);
    const node = this.state.leafNodeValues.find(item => item.id === idToEvaluate);
    if (node) {
      return node.value;
    } else {
      return rowData.leafText;
    }
  };

  updateLeafNodeValue = (id: string, value: string) => {
    const index = this.state.leafNodeValues.findIndex(item => item.id === id);
    const newArray = this.state.leafNodeValues;
    if (index === -1) {
      newArray.push({
        id: id,
        value: value,
      });
    } else {
      newArray[index] = {
        id: id,
        value: value,
      };
    }
    this.setState({
      leafNodeValues: newArray,
      latestUpdatedRow: id,
    });
    this.props.updateLeafNodeValue(id, value);
  };

  getColumns = () => {
    return [
      {
        title: i18n.t('transactions:editor.nodes'),
        field: 'name',
        cellStyle: {
          width: '60%',
        },
        render: (row: any) => {
          if (row.type === 'NODE') {
            return <span className={row.type === 'NODE' ? 'text-primary' : undefined}>{row.name}</span>;
          } else {
            return <label className={'font-weight-normal mt-2'}>{row.name}</label>;
          }
        },
      },
      {
        title: i18n.t('transactions:editor.value'),
        cellStyle: {
          width: '35%',
          paddingRight: '0.2%',
        },
        render: (row: any) => {
          return row.type === 'NODE' ? (
            ''
          ) : (
            <div className="has-form-control-icon has-form-control-icon-right w-100 pr-0">
              <input
                type="text"
                className={clsx('form-control', 'qa-text-filter', 'pr-2', 'w-100 h-100', 'cursor-pointer')}
                style={{ minWidth: '90%' }}
                onChange={() => _.noop()}
                title={this.getLeafNodeValue(row)}
                value={this.getLeafNodeValue(row)}
                autoComplete="off"
                readOnly={true}
              />
            </div>
          );
        },
      },
    ];
  };

  getBackgroundColor = (rowData: any) => {
    //Row updated last time should have yellow color
    if (this.state.latestUpdatedRow === getIdForResponseWizard(rowData)) {
      return '#fdf9e9';
    }

    return this.props.selectedNode === rowData.id ? 'red' : '#FFF';
  };

  render() {
    let data: any = [];
    data = this.props.sampleBodyJsonUi ? JSON.parse(this.props.sampleBodyJsonUi) : data;

    return (
      <div className="responseTreeWizard">
        <MaterialTable
          tableRef={this.tableRef}
          localization={{
            toolbar: {
              searchPlaceholder: i18n.t('transactions:editor.searchNodes'),
            },
          }}
          style={{
            padding: '1px',
          }}
          title=""
          data={data}
          columns={this.getColumns()}
          parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
          options={{
            selection: false,
            filtering: false,
            paging: false,
            sorting: false,
            debounceInterval: 500,
            defaultExpanded: true,
            searchFieldStyle: {
              border: '1px solid #afbacc',
              paddingLeft: '5px',
              fontSize: '14px',
              width: '99%',
              borderRadius: '3px',
            },
            headerStyle: {
              color: '#333840',
              fontSize: '14px',
              fontWeight: 'bold',
              borderTop: '1px solid #c8d1e0',
              borderBottom: '2px solid #c8d1e0',
              width: '23px',
              maxWidth: '23px',
            },
            rowStyle: rowData => ({
              backgroundColor: this.getBackgroundColor(rowData),
              width: '23px',
              maxWidth: '23px',
            }),
            draggable: false,
            toolbar: true,
            searchFieldAlignment: 'right',
            showSelectAllCheckbox: false,
            selectionProps: (rowData: any) => ({
              color: 'primary',
              disabled: rowData.type === 'NODE',
            }),
            detailPanelColumnAlignment: 'right',
          }}
          detailPanel={[
            rowData => {
              return {
                disabled: rowData.type !== 'LEAF',
                openIcon: () => (
                  <div
                    title={i18n.t('transactions:editor.collapseDVSection')}
                    className={'btn btn-primary expression-btn'}
                  >
                    {'${}'}
                  </div>
                ),
                icon: () =>
                  rowData.type === 'LEAF' ? (
                    <div
                      title={i18n.t('transactions:editor.expandDVSection')}
                      className={'btn btn-secondary expression-btn'}
                    >
                      {'${}'}
                    </div>
                  ) : (
                    <></>
                  ),
                render: rowData => {
                  if (rowData.type === 'LEAF') {
                    return (
                      <ResponseWizardDetail
                        requestBodyTreeJson={this.props.requestBodyTreeJson}
                        requestTabState={this.props.requestTabState}
                        updateLeafNodeValue={this.updateLeafNodeValue}
                        requestBodyType={this.props.requestBodyType}
                        rowData={rowData}
                        serviceId={this.props.serviceId}
                      />
                    );
                  } else {
                    return <></>;
                  }
                },
              };
            },
          ]}
        />
      </div>
    );
  }
}

export default ResponseTreeWizard;
